/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    EventAttachmentCreateParams,
    EventAttachmentCreateParamsFromJSON,
    EventAttachmentCreateParamsFromJSONTyped,
    EventAttachmentCreateParamsToJSON,
} from './EventAttachmentCreateParams';
import {
    Field,
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field';
import {
    ProgramEventSeries,
    ProgramEventSeriesFromJSON,
    ProgramEventSeriesFromJSONTyped,
    ProgramEventSeriesToJSON,
} from './ProgramEventSeries';
import {
    ProgramEventStatus,
    ProgramEventStatusFromJSON,
    ProgramEventStatusFromJSONTyped,
    ProgramEventStatusToJSON,
} from './ProgramEventStatus';
import {
    ProgramEventType,
    ProgramEventTypeFromJSON,
    ProgramEventTypeFromJSONTyped,
    ProgramEventTypeToJSON,
} from './ProgramEventType';
import {
    ProgramEventVenueCreateParams,
    ProgramEventVenueCreateParamsFromJSON,
    ProgramEventVenueCreateParamsFromJSONTyped,
    ProgramEventVenueCreateParamsToJSON,
} from './ProgramEventVenueCreateParams';
import {
    RegistrationOptionCreateParams,
    RegistrationOptionCreateParamsFromJSON,
    RegistrationOptionCreateParamsFromJSONTyped,
    RegistrationOptionCreateParamsToJSON,
} from './RegistrationOptionCreateParams';

/**
 * 
 * @export
 * @interface ProgramEventCreateParams
 */
export interface ProgramEventCreateParams {
    /**
     * 
     * @type {ProgramEventType}
     * @memberof ProgramEventCreateParams
     */
    type: ProgramEventType;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    program_id: string;
    /**
     * 
     * @type {Array<ProgramEventVenueCreateParams>}
     * @memberof ProgramEventCreateParams
     */
    venues?: Array<ProgramEventVenueCreateParams>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventCreateParams
     */
    online_event: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    online_event_url?: string;
    /**
     * 
     * @type {ProgramEventStatus}
     * @memberof ProgramEventCreateParams
     */
    status: ProgramEventStatus;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    url?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProgramEventCreateParams
     */
    starts_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProgramEventCreateParams
     */
    ends_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    terms?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    picture_file_id?: string;
    /**
     * 
     * @type {Array<Field>}
     * @memberof ProgramEventCreateParams
     */
    fields: Array<Field>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramEventCreateParams
     */
    tags: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventCreateParams
     */
    is_series?: boolean;
    /**
     * 
     * @type {Array<ProgramEventSeries>}
     * @memberof ProgramEventCreateParams
     */
    series_dates?: Array<ProgramEventSeries>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventCreateParams
     */
    show_remaining?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramEventCreateParams
     */
    restrict_to_package_ids?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventCreateParams
     */
    preregistration_enabled?: boolean;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof ProgramEventCreateParams
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    appointment_type_id?: string;
    /**
     * 
     * @type {Array<RegistrationOptionCreateParams>}
     * @memberof ProgramEventCreateParams
     */
    options?: Array<RegistrationOptionCreateParams>;
    /**
     * 
     * @type {Array<EventAttachmentCreateParams>}
     * @memberof ProgramEventCreateParams
     */
    attachments?: Array<EventAttachmentCreateParams>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventCreateParams
     */
    has_external_registration: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    external_registration_url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventCreateParams
     */
    feedback_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventCreateParams
     */
    timezone: string;
}

export function ProgramEventCreateParamsFromJSON(json: any): ProgramEventCreateParams {
    return ProgramEventCreateParamsFromJSONTyped(json, false);
}

export function ProgramEventCreateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramEventCreateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': ProgramEventTypeFromJSON(json['type']),
        'name': json['name'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'program_id': json['program_id'],
        'venues': !exists(json, 'venues') ? undefined : ((json['venues'] as Array<any>).map(ProgramEventVenueCreateParamsFromJSON)),
        'online_event': json['online_event'],
        'online_event_url': !exists(json, 'online_event_url') ? undefined : json['online_event_url'],
        'status': ProgramEventStatusFromJSON(json['status']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'starts_at': (new Date(json['starts_at'])),
        'ends_at': (new Date(json['ends_at'])),
        'terms': !exists(json, 'terms') ? undefined : json['terms'],
        'picture_file_id': !exists(json, 'picture_file_id') ? undefined : json['picture_file_id'],
        'fields': ((json['fields'] as Array<any>).map(FieldFromJSON)),
        'tags': json['tags'],
        'is_series': !exists(json, 'is_series') ? undefined : json['is_series'],
        'series_dates': !exists(json, 'series_dates') ? undefined : ((json['series_dates'] as Array<any>).map(ProgramEventSeriesFromJSON)),
        'show_remaining': !exists(json, 'show_remaining') ? undefined : json['show_remaining'],
        'restrict_to_package_ids': !exists(json, 'restrict_to_package_ids') ? undefined : json['restrict_to_package_ids'],
        'preregistration_enabled': !exists(json, 'preregistration_enabled') ? undefined : json['preregistration_enabled'],
        'currency': CurrencyCodeFromJSON(json['currency']),
        'appointment_type_id': !exists(json, 'appointment_type_id') ? undefined : json['appointment_type_id'],
        'options': !exists(json, 'options') ? undefined : ((json['options'] as Array<any>).map(RegistrationOptionCreateParamsFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(EventAttachmentCreateParamsFromJSON)),
        'has_external_registration': json['has_external_registration'],
        'external_registration_url': !exists(json, 'external_registration_url') ? undefined : json['external_registration_url'],
        'feedback_enabled': json['feedback_enabled'],
        'timezone': json['timezone'],
    };
}

export function ProgramEventCreateParamsToJSON(value?: ProgramEventCreateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': ProgramEventTypeToJSON(value.type),
        'name': value.name,
        'summary': value.summary,
        'description': value.description,
        'program_id': value.program_id,
        'venues': value.venues === undefined ? undefined : ((value.venues as Array<any>).map(ProgramEventVenueCreateParamsToJSON)),
        'online_event': value.online_event,
        'online_event_url': value.online_event_url,
        'status': ProgramEventStatusToJSON(value.status),
        'url': value.url,
        'starts_at': (value.starts_at.toISOString()),
        'ends_at': (value.ends_at.toISOString()),
        'terms': value.terms,
        'picture_file_id': value.picture_file_id,
        'fields': ((value.fields as Array<any>).map(FieldToJSON)),
        'tags': value.tags,
        'is_series': value.is_series,
        'series_dates': value.series_dates === undefined ? undefined : ((value.series_dates as Array<any>).map(ProgramEventSeriesToJSON)),
        'show_remaining': value.show_remaining,
        'restrict_to_package_ids': value.restrict_to_package_ids,
        'preregistration_enabled': value.preregistration_enabled,
        'currency': CurrencyCodeToJSON(value.currency),
        'appointment_type_id': value.appointment_type_id,
        'options': value.options === undefined ? undefined : ((value.options as Array<any>).map(RegistrationOptionCreateParamsToJSON)),
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(EventAttachmentCreateParamsToJSON)),
        'has_external_registration': value.has_external_registration,
        'external_registration_url': value.external_registration_url,
        'feedback_enabled': value.feedback_enabled,
        'timezone': value.timezone,
    };
}

